import { createBrowserRouter } from "react-router-dom";
import { routes } from "./router";

export const router = createBrowserRouter(routes);
